import React from 'react'
import classnames from 'classnames'
import { compose, defaultProps, lifecycle, withHandlers, withState } from 'recompose'

const enhance = compose(
  defaultProps({ onChange: () => {} }),
  withState('input', 'setInputValue', ''),
  withHandlers({
    handleChange: ({ setInputValue, onChange }) => e => {
      // allow users to type anything into the field,
      // but only propagate changes when the input value
      // meets the validation rules
      if (e.target.validationMessage === '') {
        setInputValue(e.target.value)
        const asNumber = parseFloat(e.target.value)
        onChange(isNaN(asNumber) ? null : asNumber)
      }
    }
  }),
  lifecycle({
    componentDidMount () {
      // if we have initial inputValue or value
      // we should force update it in state
      const { inputValue, value, setInputValue } = this.props
      const initial = (inputValue !== undefined && inputValue !== false && inputValue !== null) ? inputValue : value
      if (initial !== undefined && initial !== null && initial !== '') {
        const parsed = parseFloat(initial)
        if (!isNaN(parsed)) {
          return setInputValue(String(initial))
        }
      }
    },
    componentWillReceiveProps ({ value, inputValue, input, setInputValue }) {
      const val = (value !== undefined && value !== null) ? value : inputValue
      if (val === null || val === undefined) {
        return
      }

      // if the `value` prop changes, set inputValue to a string
      // representation of it.
      if (parseFloat(input) !== parseFloat(val)) {
        setInputValue(String(val))
      }
    }
  })
)

// Component which wraps input[type=number]. Mostly adds
// some logic around value changes to support scenarios like:
//
// 1. input is set to '500' with the cursor directly after the '5'
// 2. user deletes the '5', and the component displays '00'.
// A direct data-binding setup would have changed the value to '0' since
// the string value would be converted to a number and back to a string
// 3. user adds '3' to the beginning making the value '300'
//
const NumberInput = ({ min, max, input, extraClasses, handleChange, handleBlur, placeholder }) => (
  <input
    type='number'
    required
    className={classnames(extraClasses)}
    placeholder={placeholder}
    value={input === null ? undefined : input}
    onChange={e => handleChange(e)}
    onBlur={handleBlur}
    step='any'
    min={min}
    max={max}
  />
)

export default enhance(NumberInput)
